import { useState } from "react";
import { Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SettingTiles } from "@/components/laser/CalibrationCard";
import { card, inp, greenBtn, outcomeOf } from "@/components/laser/LaserParts";

const TIER = { same_machine: "Same machine", same_watts: "Same wattage", scaled: "Scaled from other wattage (estimate)" };

export default function DatabaseCheck({ machines }) {
  const [mid, setMid] = useState(machines[0]?.id || "");
  const [text, setText] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setRes(await api("/laser/suggest", { method: "POST", body: { machine_id: mid || machines[0]?.id, text } })); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  if (!machines.length) return null;
  return (
    <div style={{ ...card, padding: 16 }} data-testid="database-check">
      <p className="text-sm font-bold">What does the database know?</p>
      <p className="mb-3 text-xs text-neutral-400">See the test pieces and saved settings the Cleaning Agent would draw on for your machine.</p>
      <div className="flex flex-wrap gap-2">
        <select data-testid="db-check-machine" style={{ ...inp, width: "auto" }} value={mid} onChange={(e) => setMid(e.target.value)}>{machines.map((m) => <option key={m.id} value={m.id}>{m.nickname || m.name}</option>)}</select>
        <input data-testid="db-check-text" style={{ ...inp, flex: 1, minWidth: 180 }} value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && run()} placeholder="e.g. oak paint" />
        <button data-testid="db-check-run" onClick={run} disabled={busy} style={greenBtn}>{busy ? <Loader2 size={16} className="animate-spin" /> : <Search size={16} />}</button>
      </div>
      {res && (
        <div className="mt-3 flex flex-col gap-3">
          <p data-testid="db-check-counts" className="text-xs text-neutral-300">{res.counts.same_machine} on the same machine · {res.counts.same_watts} same wattage · {res.counts.scaled} scaled from other machines</p>
          {res.matches.length === 0 && <p className="text-xs text-neutral-400" data-testid="db-check-empty">Nothing yet — run a test piece and log it so the database learns.</p>}
          {res.matches.map((m, i) => (
            <div key={`${m.id}-${i}`} data-testid={`db-match-${i}`} style={{ border: "1px solid #2a2a2a", borderRadius: 10, padding: 12 }}>
              <p className="mb-2 text-xs"><b style={{ color: m.tier === "scaled" ? "#F5B700" : "#4CCC06" }}>{TIER[m.tier]}</b> · {m.machine_name} · {m.substrate_detail} / {m.contaminant} · {m.source === "saved_setting" ? "saved setting" : outcomeOf(m.outcome)[1]}</p>
              <SettingTiles s={m.settings} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
